import { ThemeProvider } from "@mui/material/styles";
import { ProviderContext, SnackbarProvider } from "notistack";
import { createContext, createRef, VFC } from "react";
import { ProvideAuth } from "../hooks/useAuth";
import { theme } from "../styles/theme";

import Root from "./Root";

export const errorContext = createContext(createRef<ProviderContext>());

const App: VFC = () => {
  const errorRef = createRef<ProviderContext>();

  return (
    <ThemeProvider theme={theme}>
      <errorContext.Provider value={errorRef}>
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
          autoHideDuration={3000}
        >
          <ProvideAuth>
            <Root />
          </ProvideAuth>
        </SnackbarProvider>
      </errorContext.Provider>
    </ThemeProvider>
  );
};

export default App;
